import React from 'react'

const GCF_Area1 = require('../../Resources/Data/GCF_Area_1.json')
const GCF_Area2 = require('../../Resources/Data/GCF_Area_2.json')
const GCF_Area3 = require('../../Resources/Data/GCF_Area_3.json')
const GCF_Area4 = null;

const GCF = { Area1: GCF_Area1, Area2: GCF_Area2, Area3: GCF_Area3, Area4: GCF_Area4 }

class Table extends React.Component {
   constructor(props) {
      super(props)
      this.state = {}
      this.state.name_area = this.props.name_area;
      this.state.area = this.props.area;
      this.state.ag = this.props.ag;
      this.state.gcf = this.props.gcf;
   }

   GetGCF() {
      var result
      var file
      var temp
      file = GCF["Area"+this.state.area]["Area_"+this.state.area].find(
        (element => {
          return (element.name === global["ar"+this.state.area].name_area) }));
      temp = global["ar"+this.state.area]
      if(!temp)
        return;
      result = file.Aggregation["area_"+temp.ag]
      result.sort(function(a, b){return b.year-a.year});
      return result
   }

   //componentWillReceiveProps(nextprops) {
  handleChange = event => {
      this.setState(state => {
         state.name_area = this.props.name_area;
         state.area = this.props.area;
         state.ag = this.props.ag;
         //state.gcf = this.props.gcf
      })
      this.setState(state => { })
   }

   renderTableHeader() {
      //let header = ["Year", "GCF"]
      let header = ["Année", "GCF"]
      return header.map((key, index) => {
         return <th key={index}>{key.toUpperCase()}</th>
      })
   }

   renderTableData() {
      var temp = this.GetGCF();
      if(!temp)
        return (<tr></tr>)
      return temp.map((element, index) => {
         if (element.nat.includes(global.nat)) {
            return (
               <tr key={element.year+"_"+index} onClick={() => { this.props.action(element.year) }}>
                  <td>{element.year}</td>
                  <td>{element.GCF.toPrecision(8)}</td>
               </tr>
            )
         } else {
           return (<tr key={element.year+"_"+index}/>);
         }
      })
   }

   render() {
      return (
         <div>
            <table id='GCF_Table'>
               <tbody>
                  <tr>{this.renderTableHeader()}</tr>
                  {this.renderTableData()}
               </tbody>
            </table>
         </div>
      )
   }
}

export default Table //exporting a component make it reusable and this is the beauty of react
